import React, { useEffect, useState } from 'react'
import {
    AppLayout, Box, DatePicker, Typography, useApi, TextField, MenuItem, LocalizationProvider,
    AdapterDayjs, dayjs, useNavigate,
    CloseIcon,
    CustomBackdrop,
} from '../../utils/globalImports'
import { Autocomplete, Grid2 } from "@mui/material";
import { headingStyles } from '../../assets/styles/CommonStyles'
import { FetchInvoices, InvoicesFilter } from '../../interfaces/Invoicing.interfaces';
import { Button, CircularProgress, Grid, Stack, Link, Dialog, Alert, IconButton, Snackbar } from '@mui/material';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { GridColDef } from '@mui/x-data-grid';
import { ProjectListingModel } from '../Dashboard';
import CustomInvoiceTable from '../../components/dataTable/CustomInvoiceTable';
import { DateFormat, InvoiceStatus } from '../../constants/constants';
 

const sortOptions = [
  { value: "invoiceNumber", text: "Project No." },
  { value: "projectName", text: "Project Name" },
  { value: "projectManager", text: "Project Manager" },

]
const AllInvoices = () => {
    const navigate = useNavigate()
    const { execute, loading } = useApi()
    const [TableData, SetTableData] = useState<FetchInvoices[]>();
    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [isRejected, setIsRejected] = useState<boolean>(false);
    const [selectedInvoiceId, setselectedInvoiceId] = useState<number>(0);
    const [selectedProjectManagerId, setSelectedProjectManagerId] = useState<number>(0);
    const [projectList, setProjectList] = useState<ProjectListingModel[]>([]);
    const [users, SetUsers] = useState<UsersModel[]>([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [RejectedReason, SetRejectedReason] = useState<string>("");
    const [selectedInvoices, setSelectedInvoices] = useState<number[]>([]);
    const [rejectSubmitAttempted, setRejectSubmitAttempted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status,setStatus]=useState<InvoiceStatus| null>(null);
    const UpdateStatus = (reject: boolean = false, invoiceId: number, projectManagerId: number) => {
        setStatus(reject ? InvoiceStatus.Rejected : InvoiceStatus.Approved);
        setIsRejected(reject);
        SetRejectedReason("");
        setRejectSubmitAttempted(false);
        setIsDialogOpen(true);
        setselectedInvoiceId(invoiceId);
        setSelectedProjectManagerId(projectManagerId);
    }
    const handleNavigateViewInvoiceMultiple=()=>{

        navigate('viewinvoices', {
      state: { selectedInvoices }
    });
        
    }
    const handleNavigate = (invoiceid?: number) => {
        navigate(`/invoicing/view/${invoiceid}`)
    }
 
    const statusConfig: Record<string, { label: string; color: string }> = {
        Submitted: { label: "Submitted", color: "#1565c0" },
        Approved:  { label: "Approved",  color: "#2e7d32" },
        Rejected:  { label: "Rejected",  color: "#c62828" },
        Draft:     { label: "Draft",     color: "#616161" },
    };

    const ProjectColumns: GridColDef[] = [
        { field: 'invoiceNumber', headerName: 'Invoice Number', flex: 1 },
        { field: 'projectName',   headerName: 'Project Name',   flex: 1.2 },
        { field: 'projectManager',headerName: 'Project Manager',flex: 1 },
        { field: 'createdDate',   headerName: 'Created Date',   flex: 1 },
        { field: 'lastUpdatedDate', headerName: 'Last Updated Date', flex: 1 },
        { field: 'amountToInvoice', headerName: 'Amount to Invoice', flex: 1 },
        { field: 'totalForecaste',  headerName: 'Total Forecasted',  flex: 1 },
        {
            field: 'statusName',
            headerName: 'Status',
            flex: 1,
            renderCell: (params) => {
                const cfg = statusConfig[params.value] ?? { label: params.value, color: "#333" };
                return (
                    <Typography
                        sx={{
                            color: cfg.color,
                            fontSize: "13px",
                            fontWeight: 600,
                        }}
                    >
                        {cfg.label}
                    </Typography>
                );
            }
        },
        {
            field: "action",
            headerName: "Action",
            flex: 1.5,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderCell: (params) => {
                const isActionable = ![1, 5, 4, 3].includes(params.row.status);
                return (
                    <Stack direction="row" spacing={0.8} alignItems="center">
                        {/* View — always visible */}
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleNavigate(params.row.invoiceId)}
                            sx={{
                                fontSize: "11px",
                                fontWeight: 600,
                                textTransform: "none",
                                borderRadius: "6px",
                                px: 1.2,
                                py: 0.3,
                                minWidth: "auto",
                                borderColor: "#1e66ab",
                                color: "#1e66ab",
                                "&:hover": { backgroundColor: "#eef2ff", borderColor: "#1e66ab" },
                            }}
                        >
                            View
                        </Button>

                        {/* Approve — only when actionable */}
                        {isActionable && (
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => UpdateStatus(false, params.row.invoiceId, params.row.projectManagerId)}
                                sx={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: "6px",
                                    px: 1.2,
                                    py: 0.3,
                                    minWidth: "auto",
                                    backgroundColor: "#2e7d32",
                                    "&:hover": { backgroundColor: "#1b5e20" },
                                }}
                            >
                                Approve
                            </Button>
                        )}

                        {/* Reject — only when actionable */}
                        {isActionable && (
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => UpdateStatus(true, params.row.invoiceId, params.row.projectManagerId)}
                                sx={{
                                    fontSize: "11px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderRadius: "6px",
                                    px: 1.2,
                                    py: 0.3,
                                    minWidth: "auto",
                                    backgroundColor: "#c62828",
                                    "&:hover": { backgroundColor: "#8e0000" },
                                }}
                            >
                                Reject
                            </Button>
                        )}
                    </Stack>
                );
            }
        },
    ];
    const statusArray = [
        
        { id: 2, label: "Submitted" },
        { id: 3, label: "Approved" },
        { id: 4, label: "Rejected" },
       
    ];
 
    interface UsersModel {
        userId: number,
        roleId: number,
        name: string
    }
 
const fetchAllInvoices = async (x?:InvoicesFilter) => {   
      const { data } = await execute<FetchInvoices[]>('post', '/Invoice/FetchInvoices', x?x:filter);
     const formattedData = (data || []).map(item => ({
          ...item,
          createdDate: item.createdDate
              ? dayjs(item.createdDate).format(DateFormat)
              : "",
          lastUpdatedDate: item.lastUpdatedDate
              ? dayjs(item.lastUpdatedDate).format(DateFormat)
              : ""
      }));
      SetTableData(formattedData);
  };
  const defaultFilter: InvoicesFilter = {
    projectId: null,
    startDate: null,
    endDate: null,
    projectManagerId: null,
    submittedBy: null,
    approvedBy: null,
    rejectedBy: null,
    createdBy: null,
    statusID: []
};
 
    const [filter, setFilter] = useState<InvoicesFilter>(defaultFilter);
 
    const fetchProjects = async () => {
        try {
            const { data } = await execute("get", "Project/GetAllProjects");
            if (data && Array.isArray(data)) {
                setProjectList(
                    data.map((item: any) => ({
                        projectId: item.projectId,
                        projectNumber: item.projectNumber,
                        projectName: item.projectName,
                        projectManagerId: item.projectManagerId,
                        projectManagerName: item.projectManagerName,
                        totalChangeDefinite: item.totalDefiniteChange,
                        totalChangeProposed: item.totalProposedChange,
                        totalChangeThirdParty: item.totalThirdPartyChange,
                        totalChangeOverall: item.totalDefiniteChange + item.totalProposedChange,
                        baselineProjectStatus: item.baselineProjectStatus,
                        baselineStatus: item.baselineStatus,
                        clientId: item.clientId,
                        clientName: item.clientName,
                        startDate: item.startDate,
                        endDate: item.endDate
                    }))
 
                );
            } else {
                setProjectList([]);
            }
 
        } catch (error) {
            console.error("Error fetching project listing", error);
            setProjectList([]);
 
        }
    };
 
    const ChangeInvoiceStatusDB = async (userID: Number, Status: number, Reason: string | null) => {
        try {
            setIsSubmitting(true);
            await execute(
                "put",
                `/Invoice/update-status/${selectedInvoiceId}`
                , {
                    status: Status,
                    UserId: userID,
                    RejectedReason: Reason
                }
            );
            setSnackbarOpen(true);
            
            fetchAllInvoices();
        } catch (error) {
            console.error("Error updating status", error);
        } finally {
            setIsSubmitting(false);
            setIsDialogOpen(false);
        }
    }
    const fetchUsers = async () => {
        try {
            const { data } = await execute<UsersModel[]>("get", "/Invoice/GetRequiredUsers");
            SetUsers(data || []);
        } catch (error) {
            console.error("Error fetching users", error);
            SetUsers([]);
        }
    };
 
    const applyFilters = () => {
        fetchAllInvoices();
        console.log("Applied Filters:", filter);
    };
 
    const clearFilters = () => {
    setFilter(defaultFilter);
    fetchAllInvoices(defaultFilter);
    };
 
    useEffect(() => {
        fetchAllInvoices();
        fetchProjects();
        fetchUsers();
    }, []);
    return (
        <AppLayout>
            {/* Page Heading */}
            <Typography sx={headingStyles}>Invoices List</Typography>
            <Box sx={{ backgroundColor: "#96c121", height: "2px", mb: 2 }} />

            {/* Filter Card */}
            <Box
                sx={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "10px",
                    p: 2.5,
                    mb: 2,
                    backgroundColor: "#fafafa",
                    boxShadow: "0px 1px 6px rgba(0,0,0,0.06)",
                }}
            >
                {/* Filter label */}
                <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#1e66ab", mb: 1.5, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    Filters
                </Typography>

                <Grid container spacing={2}>
                    {/* Project Name */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            options={projectList}
                            getOptionLabel={(option) => option.projectName || ""}
                            value={projectList.find(p => p.projectId === filter.projectId) || null}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, projectId: newValue?.projectId ?? null }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Project Name" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.projectId === value.projectId}
                            clearOnEscape
                        />
                    </Grid>

                    {/* Start Date */}
                    <Grid item xs={12} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Start Date"
                                value={filter.startDate ? dayjs(filter.startDate) : null}
                                onChange={(newValue) =>
                                    setFilter(prev => ({ ...prev, startDate: newValue ? newValue.toDate() : null }))
                                }
                                slotProps={{ textField: { fullWidth: true, size: "small" } }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* Last Date */}
                    <Grid item xs={12} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Last Date"
                                value={filter.endDate ? dayjs(filter.endDate) : null}
                                onChange={(newValue) =>
                                    setFilter(prev => ({ ...prev, endDate: newValue ? newValue.toDate() : null }))
                                }
                                slotProps={{ textField: { fullWidth: true, size: "small" } }}
                            />
                        </LocalizationProvider>
                    </Grid>

                    {/* Project Manager */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            options={users?.filter(u => u.roleId === 3) || []}
                            getOptionLabel={(option) => option.name || ""}
                            value={users?.filter(u => u.roleId === 3).find(u => u.userId === filter.projectManagerId) || null}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, projectManagerId: newValue?.userId ?? null }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Project Manager" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.userId === value.userId}
                            clearOnEscape
                        />
                    </Grid>

                    {/* Submitted By */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            options={users?.filter(u => u.roleId === 3) || []}
                            getOptionLabel={(option) => option.name || ""}
                            value={users?.filter(u => u.roleId === 3).find(u => u.userId === filter.submittedBy) || null}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, submittedBy: newValue?.userId ?? null }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Submitted By" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.userId === value.userId}
                            clearOnEscape
                        />
                    </Grid>

                    {/* Rejected By */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            options={users?.filter(u => u.roleId === 5) || []}
                            getOptionLabel={(option) => option.name || ""}
                            value={users?.filter(u => u.roleId === 5).find(u => u.userId === filter.rejectedBy) || null}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, rejectedBy: newValue?.userId ?? null }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Rejected By" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.userId === value.userId}
                            clearOnEscape
                        />
                    </Grid>

                    {/* Approved By */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            options={users?.filter(u => u.roleId === 5) || []}
                            getOptionLabel={(option) => option.name || ""}
                            value={users?.filter(u => u.roleId === 5).find(u => u.userId === filter.approvedBy) || null}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, approvedBy: newValue?.userId ?? null }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Approved By" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.userId === value.userId}
                            clearOnEscape
                        />
                    </Grid>

                    {/* Status */}
                    <Grid item xs={12} md={3}>
                        <Autocomplete
                            multiple
                            options={statusArray}
                            getOptionLabel={(option) => option.label}
                            value={statusArray.filter(s => filter.statusID?.includes(s.id))}
                            onChange={(event, newValue) =>
                                setFilter(prev => ({ ...prev, statusID: newValue.map(v => v.id) }))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Status" fullWidth size="small" />
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </Grid>

                    {/* Action Buttons */}
                    <Grid item xs={12}>
                        <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
                            <Button
                                onClick={applyFilters}
                                variant="contained"
                                sx={{
                                    backgroundColor: "#1e66ab",
                                    "&:hover": { backgroundColor: "#154f87" },
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 3,
                                }}
                            >
                                Search
                            </Button>
                            <Button
                                onClick={clearFilters}
                                variant="outlined"
                                sx={{
                                    borderColor: "#1e66ab",
                                    color: "#1e66ab",
                                    "&:hover": { backgroundColor: "#eef2ff", borderColor: "#1e66ab" },
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 3,
                                }}
                            >
                                Clear
                            </Button>
                            <Button
                                onClick={handleNavigateViewInvoiceMultiple}
                                variant="contained"
                                disabled={selectedInvoices.length === 0}
                                sx={{
                                    backgroundColor: "#96c121",
                                    "&:hover": { backgroundColor: "#7aa01a" },
                                    "&:disabled": { backgroundColor: "#e0e0e0", color: "#aaa" },
                                    borderRadius: "6px",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 3,
                                }}
                            >
                                {selectedInvoices.length > 0
                                    ? `View Selected (${selectedInvoices.length})`
                                    : "View All"}
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            {/* Table Section */}
            <Box
                sx={{
                    flex: 1,
                    borderRadius: "10px",
                    overflow: "hidden",
                    
                }}
            >
                <CustomInvoiceTable
                    sortOptions={sortOptions}
                    rows={TableData || []}
                    columns={ProjectColumns}
                    checkBox={true}
                    selectedRows={selectedInvoices}
                    setSelectedInvoices={setSelectedInvoices}
                />
            </Box>
 
            { /* Dialog Section */}
            <Dialog
                open={isDialogOpen}
                PaperProps={{
                    sx: {
                        borderRadius: "16px",
                        minWidth: "600px",
                        overflow: "hidden",
                        boxShadow: "0 8px 32px rgba(0,0,0,0.18)"
                    }
                }}
            >
                {/* Coloured header strip */}
                <Box sx={{
                    backgroundColor: isRejected ? "#c62828" : "#2e7d32",
                    px: 3, py: 2,
                    display: "flex", alignItems: "center", justifyContent: "space-between"
                }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        {isRejected
                            ? <CancelIcon sx={{ color: "#fff", fontSize: "24px" }} />
                            : <CheckCircleIcon sx={{ color: "#fff", fontSize: "24px" }} />
                        }
                        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "17px" }}>
                            {isRejected ? "Reject Invoice" : "Approve Invoice"}
                        </Typography>
                    </Box>
                    <IconButton size="small" onClick={() => setIsDialogOpen(false)} sx={{ color: "#fff" }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>

                {/* Body */}
                <Box sx={{ px: 3, pt: 3, pb: 3, display: "flex", flexDirection: "column", gap: 2 }}>
                    <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#333", textAlign: "center" }}>
                        {isRejected
                            ? "Are you sure you want to reject this invoice?"
                            : "Are you sure you want to approve this invoice?"
                        }
                    </Typography>

                    {isRejected && (
                        <TextField
                            required
                            fullWidth
                            multiline
                            minRows={3}
                            label="Rejection Reason"
                            placeholder="Enter reason for rejection..."
                            value={RejectedReason}
                            onChange={(e) => SetRejectedReason(e.target.value)}
                            error={rejectSubmitAttempted && RejectedReason.trim() === ""}
                            helperText={rejectSubmitAttempted && RejectedReason.trim() === "" ? "Rejection reason is required" : ""}
                            sx={{ mt: 1 }}
                        />
                    )}

                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 1 }}>
                        <Button
                            variant="outlined"
                            sx={{
                                minWidth: "100px", fontWeight: 600, textTransform: "none", borderRadius: "8px",
                                color: "#555", borderColor: "#ccc",
                                "&:hover": { borderColor: "#999", backgroundColor: "#f5f5f5" }
                            }}
                            onClick={() => setIsDialogOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={isSubmitting
                                ? <CircularProgress size={16} sx={{ color: "#fff" }} />
                                : isRejected ? <CancelIcon /> : <CheckCircleIcon />
                            }
                            disabled={isSubmitting}
                            sx={{
                                minWidth: "120px", fontWeight: 600, textTransform: "none", borderRadius: "8px",
                                backgroundColor: isRejected ? "#c62828" : "#2e7d32",
                                "&:hover": { backgroundColor: isRejected ? "#b71c1c" : "#1b5e20" },
                                "&.Mui-disabled": { backgroundColor: isRejected ? "#e57373" : "#81c784", color: "#fff" }
                            }}
                            onClick={() => {
                                if (isRejected) {
                                    setRejectSubmitAttempted(true);
                                    if (RejectedReason.trim() === "") return;
                                }
                                ChangeInvoiceStatusDB(
                                    selectedProjectManagerId,
                                    isRejected ? 4 : 3,
                                    isRejected ? RejectedReason : null
                                );
                            }}
                        >
                            {isSubmitting ? "Processing..." : isRejected ? "Reject" : "Approve"}
                        </Button>
                    </Box>
                </Box>
            </Dialog>
 
            { /* SnackbarSection */}
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => { setSnackbarOpen(false) }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
            >
                <Alert
                    onClose={() => { setSnackbarOpen(false) ; setStatus(null);}}
                    variant="filled"
                    sx={{
                        width: "300px",
                        backgroundColor: "green",
                        color: "white",
                        fontSize: "16px"
                    }}
                >
                   {status === InvoiceStatus.Rejected 
            ? "Invoice Rejected Successfully" 
            : "Invoice Approved Successfully"}
                </Alert>
            </Snackbar>
            <CustomBackdrop open={loading} />
 
        </AppLayout>
    )
}
 
export default AllInvoices
 